import React from "react";
import { Modal } from "react-bootstrap";

class RentalPriceModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dailyPrice: props.rental?.daily_price || "",
      isSubmitting: false,
    };
  }

  componentDidUpdate(prevProps) {
    // Réinitialiser le state quand la modal s'ouvre
    if (!prevProps.show && this.props.show && this.props.rental) {
      this.setState({
        dailyPrice: this.props.rental.daily_price || "",
        isSubmitting: false,
      });
    }
  }

  handlePriceChange = (e) => {
    this.setState({ dailyPrice: e.target.value });
  };

  handleSubmit = () => {
    const { dailyPrice } = this.state;
    const { onConfirm } = this.props;

    const price = parseFloat(dailyPrice);
    if (isNaN(price) || price < 0) {
      return;
    }

    this.setState({ isSubmitting: true });
    onConfirm(price);
  };

  render() {
    const { show, rental, isLoading, onClose } = this.props;
    const { dailyPrice, isSubmitting } = this.state;

    if (!show || !rental) return null;

    const productName = rental.product?.designation || rental.product_name || "Produit";
    const establishmentName = rental.establishment?.name || "Etablissement";
    const loading = isLoading || isSubmitting;
    const price = parseFloat(dailyPrice);
    const isFormValid = !isNaN(price) && price >= 0;

    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop={loading ? "static" : true}
        keyboard={!loading}
        centered
        size="md"
        className="rental-price-modal"
        dialogClassName="modal-dialog-rounded"
      >
        <Modal.Header className="rental-modal-header-gradient">
          <Modal.Title className="rental-modal-title">
            <i className="fas fa-euro-sign"></i>
            Modifier le prix journalier
          </Modal.Title>
          {!loading && (
            <button
              type="button"
              onClick={onClose}
              className="rental-validation-modal-close-btn"
            >
              <span>&times;</span>
            </button>
          )}
        </Modal.Header>

        <Modal.Body className="rental-modal-body">
          <div className="rental-modal-body-inner">
            <div className="rental-modal-product-section">
              <div className="rental-modal-product-label">
                Location :
              </div>
              <div className="rental-modal-product-name">{productName}</div>
              <div className="rental-modal-date-info">
                <strong>{establishmentName}</strong>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 mb-3">
              <label className="rental-modal-form-label rental-modal-form-label-required">
                Prix journalier HT (€)
              </label>
              <input
                type="number"
                step="0.01"
                min="0"
                className="rental-modal-form-input"
                value={dailyPrice}
                onChange={this.handlePriceChange}
                placeholder="0.00"
                disabled={loading}
                autoFocus
              />
              <small className="text-muted">
                Ce prix sera utilise pour calculer le montant de la location.
              </small>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="rental-modal-footer">
          <button
            onClick={onClose}
            disabled={loading}
            className="rental-modal-btn-cancel"
          >
            Annuler
          </button>
          <button
            onClick={this.handleSubmit}
            disabled={loading || !isFormValid}
            className={`rental-modal-btn-primary ${
              loading || !isFormValid
                ? "rental-modal-btn-primary-disabled"
                : "rental-modal-btn-primary-enabled"
            }`}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span>Enregistrement...</span>
              </>
            ) : (
              <>Enregistrer</>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RentalPriceModal;
